const testimonials = [
  {
    name: "Ricardo V.",
    location: "Aventura, FL — Williams Island",
    rating: 5,
    text: "I am a Venezuelan-American executive with an office near Aventura Mall. My mother in Caracas needed emergency surgery and I needed to be there within 48 hours. I pulled my passport and realized it had expired four months ago. I called Fast Passport Center in a panic. They walked me through every step, I shipped my documents overnight from the FedEx at Aventura Mall, and I had my new passport in 3 days. I made it to Caracas in time. They literally saved a family crisis.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "The Oliveira Family",
    location: "Aventura, FL — The Peninsula",
    rating: 5,
    text: "We are a Brazilian family living at The Peninsula and we travel to Sao Paulo every Christmas to see grandparents. This year, in November, we discovered both of our children's passports had expired — one in June, one in August. We had flights booked from MIA on December 20th. Fast Passport Center processed both child passports in 5 business days. The team was incredibly patient with the parental consent requirements and made sure we had everything correct before submission. We made our Christmas trip. I recommend them to every Brazilian family I know in Aventura.",
    service: "Child Passport Renewal",
  },
  {
    name: "Camila R.",
    location: "Aventura, FL — Turnberry Isle",
    rating: 5,
    text: "I am a Colombian entrepreneur and I had a critical investor meeting in Medellin scheduled for a Monday. On Wednesday afternoon I realized my passport had water damage from a pool day at Turnberry Isle and was no longer valid. I thought I would have to cancel the meeting and potentially lose the investment. Fast Passport Center processed a damaged passport replacement in 72 hours. I shipped Thursday morning, had my new passport by Saturday, and made my Monday meeting. Their team understood the business urgency and treated it like the priority it was.",
    service: "Damaged Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function AventuraTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Aventura Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Aventura residents who trusted Fast Passport Center with their expedited passports — from Williams Island to Turnberry Isle to The Peninsula.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}